import styled from 'styled-components/macro';

export const Form = styled.form`
  width: 100%;
`;
